<div class="idle-dialog">
  <div class="idle-dialog__header">
    <button class="idle-dialog__close" (click)="continueSession()" aria-label="Continue session">✕</button>
  </div>

  <div class="idle-dialog__body">
    <div class="idle-dialog__icon-wrap">
      <mat-icon class="idle-dialog__icon">warning_amber</mat-icon>
    </div>

    <h2 class="idle-dialog__title">We noticed you've been inactive.</h2>
    <p class="idle-dialog__subtitle">Choose <strong>Continue session</strong> to keep working.</p>

    <div class="idle-dialog__countdown">
      <mat-icon class="countdown-icon">schedule</mat-icon>
      <span>Auto-logout in <strong class="countdown-value" [class.urgent]="countdown <= 10">{{ countdown }}s</strong></span>
    </div>

    <div class="idle-dialog__actions">
      <button class="idle-btn idle-btn--primary" (click)="continueSession()">Continue session</button>
      <button class="idle-btn idle-btn--secondary" (click)="logout()">Logout now</button>
    </div>
  </div>
</div>
